import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from "react-router-dom";
import {DownloadReportModal, Modal} from "react-spaceship-web";
import ShipmentProductAudit from "./ShipmentProductAudit";
import {history} from "./AppProvider";
import RenderV1Page from "./RenderV1Page";

export default class ProductStockLastHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	route() {
		window.Route.on({
			'/v2/product-stock-last-history': () => {
				let qs = window.Global.getAllQueryStrings();
				if (!qs.stock_id) {
					qs.stock_id = '';
				}
				if (!qs.search_query) {
					qs.search_query = '';
				}
				if (!qs.end_date) {
					qs.end_date = '';
				}
				// qs.request_data_stock_alert = true;
				qs.request_data_last_history = true;
				qs.is_show_zero = true;

				this.setState({
					mode: 'list',
					is_loading: true,
					stocks: [],
					products: [],
					qs: qs
				}, () => {
					this.fetch();
				})
			},
		}).match();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.route();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.route();
		}
	}

	componentDidMount() {
		this.route();
	}

	fetch() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product/quantity_in_stock',
			data: {
				...this.state.qs,
				limit: 50,
			},
			done: (response2) => {
				if (!response2.success) {
					return false;
				}

				this.setState({
					is_loading: false,
					company_info: response2.company_info,
					products: response2.product,
					is_current: response2.is_current,
					stock: response2.stock || false,
					has_products: response2.has_products || [],
				}, () => {
					this.$parent.find('.table').tablePagination({
						disableContent: true,
						data: response2.product,
						count: response2.count,
						maxSize: 50,
						onClickPagination: (p) => {
							let qs = {...this.state.qs};
							qs.page = p;
							this.props.history.push(
								window.Global.getQueryStringLinkFromObject(qs)
							);
						}
					});
				});
			}
		})
	}

	downloadReport() {
		ReactDOM.render(
			<div>
				<Modal
					closable={false}
					onShowToSetupForm={($modal) => {
						$modal.find('form').form2('setup');
						$modal.find('.approve').off('click').on('click', (e) => {
							e.preventDefault();

							let data = window.Global.getAllQueryStrings();
							data.is_download_excel = 1;
							// data.is_show_zero = 1;
							data.request_data_last_history = 1;
							data = Object.assign(data, $modal.find('form').serializeObject());

							window.Global.reactToDom(
								window.$('body'),
								<DownloadReportModal
									url={process.env.REACT_APP_DOMAIN + '/api/product/quantity_in_stock'}
									data={data}/>
							);

							$modal.find('.deny').trigger('click');

							return false;
						})
					}}
					onHide={() => {
						ReactDOM.unmountComponentAtNode(
							document.getElementById('modal')
						);
					}}
				>
					<div className="header">ดาวโหลดรายงาน</div>
					<div className="content">
						<form className="ui form" autoComplete="off">
							<div className="field">
								<div className="flex row" style={{margin: '0 0 .5rem 0'}}>
									<div className="ui checkbox" data-form2_setup="">
										<input id="is_show_zero"
										       type="checkbox"
										       tabIndex="-1"
										       name="is_show_zero"
										       defaultChecked={false}
										/>
									</div>
									<label htmlFor="is_show_zero">แสดงรายการสินค้าที่มี <u>ยอดคงเหลือเป็นศูนย์</u></label>
								</div>
								<div className="flex row" style={{margin: '0 0 .5rem 0'}}>
									<div className="ui checkbox" data-form2_setup="">
										<input id="is_show_negative"
										       type="checkbox"
										       tabIndex="-1"
										       name="is_show_negative"
										       defaultChecked={true}
										/>
									</div>
									<label htmlFor="is_show_negative">แสดงรายการสินค้าที่มี <u>ยอดคงเหลือติดลบ</u></label>
								</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div
									className="ui approve green right button">ดาวโหลดรายงาน
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>,
			window.$('#modal').get(0)
		);
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
				// key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				  className="main ui container">
				{this.state.modal}
				<div id="modal"/>
				<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<Link className="active section" to="/v2/product-stock-last-history">ความเคลื่อนไหวสินค้า</Link>
							<span className="divider" style={{margin: '0 0.7rem'}}>:</span>
							<span className="active section">
								<span className={'relative'}>
									จำนวนวันไม่เคลื่อนไหว <span
									className={'ui label green mini absolute -top-3 -right-6'}>ใหม่</span>
								</span>
							</span>
						</div>
					</div>
					<div className="right floated">
						{/*<Link className="ui positive button"*/}
						{/*      to={"/v2/products/new"}>เพิ่มสินค้าใหม่</Link>*/}
					</div>
				</div>
				<div id="Search_root"
				     className="box"
				     style={{display: 'none', marginTop: '1rem'}}
				     ref={(ref) => {
					     let $search = window.$(ref);
					     $search.find('input[name="stock_id"]').val(this.state.qs.stock_id);
					     window.Search.init({
						     $node: $search,
						     onSubmit: (data) => {
							     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
							     return false;
						     }
					     });
					     $search.find('#download-report-button').off('click').on('click', () => {
						     this.downloadReport();
					     });

					     let $product_ids = $search.find('input[name="product_ids[]"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/product',
						     additionalData: () => {
							     return {
								     page: 1,
								     limit: 30,
								     is_not_count_stock: 0,
								     exclude_product_id: $product_ids.explorer('get value')
							     }
						     },
						     key: 'product',
						     multiple: true,
						     template: {
							     list: (value) => {
								     let search = $product_ids.find('input[name="search"]').val();
								     return window.GlobalTemplate.getProductSearchList(search, value);
							     },
							     selected: {
								     display_template: '<span>{{name}} <a href="/v2/products/{{id}}" target="_blank"><i class="icon linkify"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tstyle="font-size: 0.8rem;margin: 0;color: #646464;"></i></a></span>',
								     value: 'id',
								     placeholder: 'ไม่กำหนด'
							     }
						     },
						     onSelected: () => {
							     let data = $search.find('form').serializeObject()
							     history.push(window.Global.getQueryStringLinkFromObject(data))
						     },
						     onUnSelected: () => {
							     let data = $search.find('form').serializeObject()
							     history.push(window.Global.getQueryStringLinkFromObject(data))
						     }
					     });

					     this.state.has_products.map((v) => {
						     $product_ids.explorer('set selected', v);
						     return true
					     })
				     }}
				>
					<form className="ui form">
						<div className="flex row wrap padded four column computer">
							<div className="column field">
								<label htmlFor="">ค้นหาสินค้า (เลือกหลายสินค้าได้)</label>
								<input type="text"
								       name="product_ids[]"
								       placeholder=""
								       autoComplete="off"
								/>
							</div>
							<div className="column field">
								<label htmlFor="">ค้นหาสินค้า</label>
								<input type="text"
								       name="search_query"
								       placeholder="ชื่อสินค้า/รหัส"
								       autoComplete="off"
								/>
								<input type="hidden" name="stock_id"/>
							</div>
							<div className="column fluid field right floated">
								<label htmlFor="">&nbsp;</label>
								<div className="flex row wrap">
									<button id="download-report-button"
									        className="ui button basic"
									        type="button">
										ดาวโหลดรายงาน
									</button>
									<button className="ui button primary" type="submit">ค้นหา</button>
								</div>
							</div>
						</div>
						{
							!this.state.is_current
								?
								<div style={{paddingBottom: '1rem'}}>
									<span style={{color: 'green'}}
									      data-tooltip="หากเลือกดูข้อมูลวันย้อนหลัง และมีการเปลี่ยนแปลงเอกสารต่างๆ ซึ่งจะส่งผลกับยอดคงเหลือ ณ วันที่ที่ระบุ ยอดสินค้าคงเหลือจะอัพเดทล่าสุดทุกๆ 6 ชม."
									      data-position="top left center bottom right"
									      data-inverted="">
										<i className="icon info circle"/> ข้อมูลอัพเดทล่าสุดเมื่อ <b>{window.Global.getDateThai(this.state.company_info.chart_product_cost_calculate_last_date, {is_show_time: 1})} ณ.</b>
									</span>
								</div>
								: null
						}
					</form>
				</div>
				<div className="flex row wrap mt-6">
					<div className="ui basic table can click Table_root" style={{marginTop: 0}}>
						<div className="thead">
							<div className="tr">
								<div className="th col-lg-3-5">สินค้า</div>
								<div className="th col-lg-1">
									จำนวนวัน
									<br/>
									<span className={'text-xs'}>ไม่เคลื่อนไหว</span>
								</div>
								<div className="th col-lg-1">
									อายุสินค้า (วัน)
									<br/>
									<span className={'text-xs'}>ตั้งแต่รับเข้า</span>
								</div>
								<div className="th col-lg-2-5">ขาเข้าล่าสุด</div>
								<div className="th col-lg-2-5">ขาออกล่าสุด</div>
								<div className="th col-lg-1">มีอยู่ในคลัง</div>
								<div className="th col-lg-1">กำลังสั่งซื้อ</div>
								<div className="th col-lg-1">พร้อมใช้งาน</div>
								<div className="th col-lg-1">เตรียมขาย</div>
								<div className="th col-lg-1-5">ราคาทุนเฉลี่ย<br/>/คิดเป็นมูลค่า (฿)</div>
							</div>
						</div>
						<div className="tbody">
							{
								this.state.products.length === 0
									? <div className="td span16" style={{textAlign: 'center'}}>ยังไม่มีข้อมูล</div>
									: null
							}
							{
								this.state.products.map((product, i) => {
									if (this.state.qs.product_ids) {
										let _product_ids = []
										let __product_ids = this.state.qs.product_ids.split(',')
										__product_ids.map((v) => {
											_product_ids.push(parseInt(v))
											return true
										})

										if (_product_ids.indexOf(product.id) === -1) {
											return null;
										}
									}

									return (
										<div key={i}
										     className={
											     "tr group/item " + (
												     product.stock_alert
												     && (product.stock_alert.is_alert_minimum
													     || product.stock_alert.is_alert_maximum
												     ) ? " stock-alert " : ""
											     )}
										>
											<div className='td col-lg-3-5'>
												<div>
													<div className='flex row middle-xs'>
														<a href={'/v2/products/' + product.product.id}
														   className={'mr-4'}
														>
															<img src={product.product.product_image_file_upload.url}
															     alt={product.product.name}
															     className={'w-20 h-20 rounded-full'}
															/>
														</a>
														<div>
															<a href={'/v2/products/' + product.product.id}
															   className='link'>
																<b>{product.product.name}</b>
															</a>
															<br/><span style={{
															color: '#858585',
															fontSize: '0.8rem'
														}}>{product.product.code}</span>
															<div className={'mt-1 flex flex-row wrap'}>
																<div className={'mr-2'}>
																	<Link className="ui icon green basic mini button"
																	      to={"/v2/shipments?has_product_ids=" + product.product.id + "&order_by=done_date_desc"}>
																		<i className="info icon"
																		   style={{height: 'initial'}}/> ดูประวัติล่าสุด
																	</Link>
																</div>
																<div>
																	<div className="ui icon green basic mini button"
																	     onClick={() => {
																		     window.Global.reactToDom(
																			     window.$('body'),
																			     <ShipmentProductAudit
																				     product={product.product}
																			     />
																		     );
																	     }}>
																		<i className="history icon"
																		   style={{height: 'initial'}}/> ตรวจสอบสินค้า
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className='td col-lg-1'>
												<div className={'flex flex-row'}>
													{
														product.last_history.no_day_1
															? (
																<div
																	className={'px-3 py-2 bg-orange-200 text-orange-800 font-bold rounded'}>
																	{product.last_history.no_day_1.format(0)}
																</div>
															)
															: '-'
													}
												</div>
											</div>
											<div className='td col-lg-1'>
												<div>
													{
														product.last_history.no_day_2
															? product.last_history.no_day_2.format(0)
															: '-'
													}
												</div>
											</div>
											<div className='td col-lg-2-5'>
												<div className={''}>
													{
														product.last_history.in_shipments.map((in_shipment, i) => {
															return (
																<History i={i} shipment={in_shipment} product={product}/>
															)
														})
													}
												</div>
											</div>
											<div className='td col-lg-2-5'>
												<div className={''}>
													{
														product.last_history.out_shipments.map((out_shipment, i) => {
															return (
																<History i={i} shipment={out_shipment} product={product}/>
															)
														})
													}
												</div>
											</div>
											<div className='td col-lg-1'>
												<div>
													<div>
														{
															window.GlobalFunc.getUnitNameByQuantity2({
																product: product.product,
																quantity: product.product_stock.on_hand,
																ratio: product.check_stock_display_ratio
															})['text']
														}
													</div>
													{
														product.stock_alert
														&& product.stock_alert.is_alert_minimum
															?
															<div>
																<div className='ui label red tiny'>
																	{"< "}{window.GlobalFunc.getUnitNameByQuantity2({
																	product: product.product,
																	quantity: product.stock_alert.stock_alert.minimum,
																	ratio: product.stock_alert.stock_alert.minimum_ratio
																})['text']}
																</div>
															</div> : null
													}
													{
														product.stock_alert
														&& product.stock_alert.is_alert_maximum
															?
															<div>
																<div className='ui label red tiny'>
																	{"> "}{window.GlobalFunc.getUnitNameByQuantity2({
																	product: product.product,
																	quantity: product.stock_alert.stock_alert.maximum,
																	ratio: product.stock_alert.stock_alert.maximum_ratio
																})['text']}
																</div>
															</div> : null
													}
												</div>
											</div>
											<div className='td col-lg-1'>
												{
													this.state.is_current
														?
														window.GlobalFunc.getUnitNameByQuantity2({
															product: product.product,
															quantity: product.product_stock.incoming,
															ratio: product.check_stock_display_ratio
														})['text']
														: '-'
												}
											</div>
											<div className='td col-lg-1'>
												{
													this.state.is_current
														?
														window.GlobalFunc.getUnitNameByQuantity2({
															product: product.product,
															quantity: product.product_stock.available,
															ratio: product.check_stock_display_ratio
														})['text']
														: '-'
												}
											</div>
											<div className='td col-lg-1'>
												{
													this.state.is_current
														?
														window.GlobalFunc.getUnitNameByQuantity2({
															product: product.product,
															quantity: product.product_stock.committed,
															ratio: product.check_stock_display_ratio
														})['text']
														: '-'
												}
											</div>
											<div className='td col-lg-1-5'>
												<div>
													{
														product.chart_product_cost.is_found
															?
															<div className={'flex flex-row'}>
																<div>
																	{product.chart_product_cost.price_average_exclude_vat.format(2)}
																	<br/>
																	<span style={{color: 'grey', fontSize: '0.9rem'}}
																	      data-tooltip={'คำนวนจากใบเสร็จซื้อและยอดยกมา (ทั้งหมด ' + window.GlobalFunc.getUnitNameByQuantity2({
																		      product: product['product'],
																		      quantity: product['chart_product_cost']['quantity'],
																		      ratio: product['check_stock_display_ratio']
																	      })['text'] + ')'}
																	      data-inverted=''
																	      data-position={'top right'}
																	>
																		<i className="icon info circle"/>
																	</span>
																</div>
																<div className={'ml-auto'}>
																	<b>
																		{
																			(
																				product['chart_product_cost']['quantity'] * product.chart_product_cost.price_average_exclude_vat
																			).format(2)
																		}
																	</b>
																</div>
															</div>
															: '-'
													}
												</div>
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		if (!this.state.mode || this.state.is_loading) {
			return <div className="ui active centered inline loader"/>
		}
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		return null;
	}
}

function History({i, shipment, product}) {
	return (
		<div key={shipment.id}
		     className={
			     ' inline-flex flex-row items-center '
		     }
		>
			<a key={shipment.id}
			   href={
				   shipment.url
					   ? shipment.url
					   : '/v2/products/' + product.id
			   }
			   className={'inline-flex flex-row items-center link'}
			>
				{shipment.title} <span
				className={'ml-1 text-xs'}>{window.Global.getDateThai(shipment.done_date, {is_show_time: false})}</span>
			</a>
			<span className={'ml-2 invisible group-hover/item:visible text-gray-400 hover:text-gray-800 cursor-pointer '}
			      data-tooltip={'ดูด่วน'}
			      data-inverted={''}
			      onClick={() => {
				      window.Global.reactToDom(
					      window.$('body'),
					      RenderV1Page,
					      {
						      url: shipment.url,
					      }
				      )
			      }}>
				<i className="eye icon text-xs"
				   style={{marginRight: 0}}></i>
			</span>
		</div>
	)
}
